import { useEffect } from "react";
import { SignUp } from "@clerk/react-router";
import { Logo } from "@/components/Logo";
import Footer from "@/components/Footer";
import { setMetaDescription, setCanonicalUrl, setOpenGraphTags, setTwitterCardTags, setMetaRobots } from "@/lib/seo";
import { generateWebPageSchema, addSchemaToPage } from "@/lib/schema";

export default function Signup() {
  useEffect(() => {
    const title = "Sign Up - Munthly";
    const description = "Create your free Munthly account and start budgeting today. Join thousands of users taking control of their finances with our free budgeting tool.";
    
    document.title = title;
    setMetaDescription(description);
    const canonicalCleanup = setCanonicalUrl("/signup");
    const ogCleanup = setOpenGraphTags(title, description, "/signup");
    const twitterCleanup = setTwitterCardTags(title, description);
    const robotsCleanup = setMetaRobots("noindex, nofollow"); // Don't index signup page
    
    // Add schema for signup page
    const webPageSchema = generateWebPageSchema(
      "/signup",
      title,
      description
    );
    
    const schemaCleanup = addSchemaToPage(webPageSchema);
    
    return () => {
      canonicalCleanup();
      ogCleanup();
      twitterCleanup();
      robotsCleanup();
      schemaCleanup();
    };
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-md space-y-6">
          <div className="flex items-center justify-center mb-4">
            <Logo variant="small" className="h-16 w-auto" />
          </div>
          <SignUp
            appearance={{
              elements: {
                rootBox: "mx-auto",
                card: "shadow-none border-0 bg-[var(--surface-container)]",
              },
            }}
            routing="path"
            path="/signup"
            signInUrl="/signin"
            afterSignUpUrl="/dashboard"
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}
